import './speedSetting.scss';
import { useImmer } from 'use-immer';
import { lang } from '@umu/ukit-lang';
import { isMobile } from '@umu/umu-ua';
import React, { useEffect } from 'react';
import { Iconfont } from '@umu/umu-design';
import { If } from 'common/src/components';
import { LabelAndValueOptions } from '../interface';

type SpeedSettingProps = {
    uControlBar: any;
    emitCustomEvent: any;
    speed: LabelAndValueOptions;
    setSpeed: (value: LabelAndValueOptions)=> void;
};

function SpeedSetting(props: SpeedSettingProps) {
    const { speed, setSpeed, uControlBar, emitCustomEvent } = props;

    const [speedOptions, setSpeedOptions] = useImmer<LabelAndValueOptions[]>([]);

    const handleChangeOptionsSelected = (index: number) => {
        const item = speedOptions[index];
        setSpeed(speedOptions[index]);
        emitCustomEvent('u-select:speed', uControlBar.wrapContainer, { value: item.value });
    };

    const transformSpeedOptions = ()=>{
        return uControlBar!.config!.speedOptions.map((item: string)=>{
            return {
                label: item + 'X',
                value: item,
                isSelected: Number(item) === 1
            }
        });
    }

    useEffect(()=>{
        setSpeedOptions(transformSpeedOptions());
    },[uControlBar?.config?.speedOptions]);

    return (
        <div className={`u-player-speed-setting ${isMobile ? 'm' : 'pc'}`}>
            <If condition={!isMobile}>
                <div className="speed-setting-title">
                    <div className="speed-setting-title-content">{lang('倍速')}</div>
                </div>
            </If>

            <div className="speed-setting-options-list">
                <div className="speed-setting-options-list-container">
                    {speedOptions.map((item,index) => {
                        return (
                            <div
                                key={item.value}
                                className={`speed-setting-options-item ${String(speed.value) === String(item.value) ? 'active' : ''}`}
                                onClick={() => handleChangeOptionsSelected(index)}
                            >
                                <If condition={!isMobile}>
                                    <div className="speed-setting-options-item-selected-flag">
                                        <If condition={String(speed.value) === String(item.value)}>
                                            <Iconfont type="Complete" />
                                        </If>
                                    </div>
                                </If>

                                <div className="speed-setting-options-item-label">{item.label}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default SpeedSetting;
